export default function Blacklisted({ reason }: { reason: string }) {
  return (
    <section className="blacklisted">
      <h1>BLOCKLISTED</h1>
      {reason ? <p>{reason}</p> : null}
    </section>
  );
}
